import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import {
  DealItem,
  DealItemWithVersions,
} from '@/lib/graphql/generated/graphql';
import { Row } from '@tanstack/react-table';

import { ExtendedColumnDef } from '../table-products';

const linesToText = (arr?: string[] | string | null): string => {
  if (typeof arr === 'string') return arr;
  return arr && arr.length ? arr.join('\n') : '';
};

const useColumnDefCouponHowToUse =
  (): ExtendedColumnDef<DealItemWithVersions> => {
    const { t } = useTranslation();

    const getValue = (row: Row<DealItemWithVersions>) => {
      return row.original.activeVersion.couponHowToUse;
    };

    const getParentValue = () => {
      return '—';
    };

    const accessorKey: keyof DealItem = 'couponHowToUse';
    return useMemo(
      () => ({
        accessorKey: accessorKey,
        name: "Étapes d'utilisation",
        header: () => (
          <div className="flex items-center">{t('kpi.coupon_how_to_use')}</div>
        ),
        cell: ({ row }) => {
          const isParent = row.subRows.length > 1;
          const displayValue = isParent ? getParentValue() : getValue(row);

          return (
            <div className="h-full w-full">
              <Tooltip>
                <TooltipTrigger asChild>
                  <div className="flex h-full w-full max-w-[200px] items-center truncate px-2 text-sm">
                    {linesToText(displayValue as string[] | null) || '—'}
                  </div>
                </TooltipTrigger>
                <TooltipContent>
                  <div className="max-w-[300px] whitespace-pre-wrap">
                    {linesToText(displayValue as string[] | null) ||
                      'Aucune instruction définie'}
                  </div>
                </TooltipContent>
              </Tooltip>
            </div>
          );
        },
        size: 320,
      }),
      [t]
    );
  };

export default useColumnDefCouponHowToUse;
